import { styled, css } from 'styled-components';

import { Media } from '../../../../../theme/Media.tsx';
import { MOBILE_PADDING, SECTION_PADDING_COMPACT, SECTION_PADDING_DEFAULT } from '../../constants.ts';

export const InfoWrapper = styled.div`
  background: ${({ theme }) => theme.colors.grey00_1};
  white-space: nowrap;
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media ${Media.xsMax} {
    flex-direction: column;
    align-items: stretch;
  }
`;

interface InfoInnerProps {
  $increasedVerticalPadding: boolean;
  $topBorder: boolean;
  $withSorting: boolean;
  $compact: boolean;
}

export const InfoInner = styled.div<InfoInnerProps>`
  padding: ${({ $increasedVerticalPadding, $compact }) =>
    $compact
      ? $increasedVerticalPadding
        ? '12px'
        : SECTION_PADDING_COMPACT
      : $increasedVerticalPadding
        ? '24px'
        : SECTION_PADDING_DEFAULT};
  display: flex;
  align-items: center;
  gap: 8px;

  @media ${Media.smMin} {
    flex-grow: 1;
  }

  @media ${Media.xsMax} {
    width: 100%;
    padding: ${MOBILE_PADDING};

    ${({ $topBorder }) =>
      $topBorder &&
      css`
        border-top: 1px solid ${({ theme }) => theme.colors.grey10_1};
      `}

    ${({ $withSorting }) =>
      !$withSorting &&
      css`
        justify-content: space-between;

        & > :nth-child(1) {
          order: 2;
        }

        & > :nth-child(2) {
          order: 1;
        }

        & > :nth-child(3) {
          order: 3;
        }
      `}
  }
`;

interface PageInfoWrapperProps {
  $mobileMlAuto: boolean;
}

export const PageInfoWrapper = styled.div<PageInfoWrapperProps>`
  @media ${Media.smMin} {
    margin-left: auto;
  }

  @media ${Media.xsMax} {
    ${({ $mobileMlAuto }) =>
      $mobileMlAuto &&
      css`
        margin-left: auto;
      `}
  }
`;

interface CompactProps {
  $compact: boolean;
}

export const FiltersWrapper = styled.div<CompactProps>`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  padding: ${({ $compact }) => ($compact ? SECTION_PADDING_COMPACT : SECTION_PADDING_DEFAULT)};

  @media ${Media.xsMax} {
    flex-direction: column;
    align-items: stretch;
    padding: 12px;
  }
`;

export const BulkActionsLabel = styled.div`
  @media ${Media.xsMax} {
    min-width: calc(100% - 36px - 8px); /* 36px icon button + 8px gap */
  }
`;

export const BulkActionsWrapper = styled.div<CompactProps>`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  padding: ${({ $compact }) => ($compact ? SECTION_PADDING_COMPACT : SECTION_PADDING_DEFAULT)};

  @media ${Media.xsMax} {
    padding: 12px;
  }
`;
